import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"

interface UseCompanyAddressOptions {
  variables: {
    companyId: string
  }
}

const PAYMENTS_COMPANY_GET_COMPANY_ADDRESS = gql`
  query PaymentsCompanyGetCompanyAddress($companyId: ID!) {
    company(companyId: $companyId) {
      id
      billingAddress {
        id
        createdAt
        addressLine1
        addressLine2
        city
        region
        postalCode
        countryCode
      }
      address {
        id
        createdAt
        addressLine1
        addressLine2
        city
        region
        postalCode
        countryCode
      }
    }
  }
`

const useCompanyAddress = (options: UseCompanyAddressOptions) => {
  return useQuery(PAYMENTS_COMPANY_GET_COMPANY_ADDRESS, options)
}

export default useCompanyAddress
